import React, { useContext, useRef, useState } from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Image from "next/legacy/image";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import useDevice from "../../customHooks/useDevice";
import Markdown from "../../styles/Markdown";

const StyledLoaderWrapper = styled.div`
  min-height: ${({ height }) => `${height || "25rem"}`};
`;

const StyledPlaceholderTextWrapper = styled.div`
  z-index: 1;
  background-color: white;
  opacity: 0.85;

  h1 {
    opacity: 1;
    color: black;
  }
`;

const StyledTextWrapper = styled.div`
  z-index: 1;
`;

const StyledImage = styled(Image)`
  filter: blur(4px);
`;

function MapLoader(props) {
  const { children, showText = true, hideText  } = props;

  const {
    staticImage,
    height,
    text,
    loaderText,
    useTextAsCover,
    mobileHeight,
    alwaysShowImage,
    loadMarkersOnMount = false
  } = useContext(ComponentContext);
  const ref = useRef();
  const { isMobile } = useDevice();

  const [isMapLoaded, setIsMapLoaded] = useState(loadMarkersOnMount);

  const imageUrl = staticImage?.url;
  const placeholderText = !isEmpty(loaderText)
    ? loaderText
    : "Click here to see where our current vacancies are";

  const isImageLoaderUsed = imageUrl && alwaysShowImage ? true : !isMobile;

  const textPlaceholderClassname = classNames(
    "p-3 p-md-5 rounded text-center w-75",
    { "shadow-lg": isMobile }
  );

  const loader = (
    <>
      {isImageLoaderUsed && (
        <StyledImage alt="Map placeholder" layout="fill" src={imageUrl} />
      )}

      {useTextAsCover ? (
        <StyledTextWrapper
          className="map-loader-text"
          onClick={() => setIsMapLoaded(true)}
          >
          <Markdown>{text}</Markdown>
        </StyledTextWrapper>
      ) : (
        <StyledPlaceholderTextWrapper className={textPlaceholderClassname}>
          <h1>{placeholderText}</h1>
        </StyledPlaceholderTextWrapper>
      )}
    </>
  );

  return (
    <StyledLoaderWrapper
      ref={ref}
      height={`${ref?.current?.clientHeight}px`}
      onClick={() => setIsMapLoaded(true)}
    >
      {!isMapLoaded && (
        <>
          {showText && !hideText && !useTextAsCover && (
            <Markdown>{text}</Markdown>
          )}
          <StyledLoaderWrapper
            className="d-flex flex-column justify-content-center align-items-center position-relative"
            height={isMobile ? mobileHeight : height}
          >
            {loader}
          </StyledLoaderWrapper>
        </>
      )}
      {isMapLoaded && children}
    </StyledLoaderWrapper>
  );
}

export default observer(MapLoader);
